import { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import CheckBoxGroup from './checkbox'
import './checkbox.css'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import GetmoviesAppInfoConfigService from '../../Services/Queries/GetmoviesAppInfoConfigService'
const Genre = props => {
  // props for this file from parent
  const { sendinputdata, sendtruevalue, genRe, inputData } = props
  const [showPopup, setshowPopup] = useState(false)
  const [optionsObject, setoptionsObject] = useState({})
  const [disableOK, setdisableOk] = useState(true)
  const sendOptions = data => {
    setoptionsObject(data)
  }

  // function to show popup
  function genReshowPopup() {
    if (showPopup === true) {
      setshowPopup(false)
    } else {
      setshowPopup(true)
    }
  }

  // function to simplify objects and send selected values to parent
  const genResend = () => {
    const optionsObjectTemp = [...optionsObject]

    const finalEnglishgenredisplayvalues = []

    const finalValues = optionsObjectTemp.map((element, index) => {
      if (element.selected === true) {
        finalEnglishgenredisplayvalues.push(element.value)
      }

      if (index === optionsObjectTemp.length - 1) {
        return { finalEnglishgenredisplayvalues }
      }

      return undefined
    })
    const finalValuesWithouthEmpty = finalValues.filter(item => item !== undefined)
    const inputData = { ...props.inputData }
    inputData.genRe = finalValuesWithouthEmpty[0].finalEnglishgenredisplayvalues
    sendinputdata(inputData)
    sendtruevalue('genre', true)
  }

  // useEffect for getting genres from service and  to show redendered values as selcted in popup
  useEffect(() => {
    const GetmoviesAppInfo = async () => {
      const appInfoData = await GetmoviesAppInfoConfigService()

      const optionsObject = appInfoData.getMoviesAppInfoConfig.genres.map(e => ({
        ...e,
        text: e.label,
        selected: false,
      }))
      const genereField = [...optionsObject]
      const genReTemp = genRe ? genRe : ''
      genReTemp.forEach(genReTempvalue => {
        const indexOfanElement = genereField.findIndex(genre => genre.value === genReTempvalue)
        if (indexOfanElement > -1) {
          genereField[indexOfanElement].selected = true
        }
      })
      setoptionsObject(genereField)
    }

    GetmoviesAppInfo()
  }, [props.genRe])
  return (
    <div>
      <Row>
        <Col md={6} xs={12}>
          <div className='shotbio  margintop'>
            <label>
              Genre_En:<div className='mandatory'>*</div>
            </label>
            {genRe.length >= 1 && (
              <div
                onClick={() => setshowPopup(true)}
                className='rounded'
                style={{ display: 'flex', flexWrap: 'wrap', border: '1px solid lightgray' }}
              >
                {genRe &&
                  genRe.map((e, index) => (
                    <span
                      style={{
                        margin: '5px',
                        border: '1px solid black',
                        padding: '1px',
                        borderRadius: '1rem',
                      }}
                      key={index}
                    >
                      {e}
                    </span>
                  ))}
              </div>
            )}
            {genRe.length < 1 && (
              <input
                type='text'
                className='form-control'
                placeholder={`enter genre of ${
                  inputData.contentType === 'movies' ? 'movie' : 'webseries'
                }`}
                value={genRe}
                onClick={() => genReshowPopup()}
              />
            )}
          </div>
        </Col>
      </Row>
      {showPopup && (
        <Modal
          show={genReshowPopup}
          dialogClassName='modal-90w'
          // fullscreen={'md-down'}
          onHide={() => setshowPopup(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Movie Genre:</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/*  <div>{genreback1}</div> */}
            <CheckBoxGroup
              checkboxObj={optionsObject}
              sendoptions={sendOptions}
              setdisableOk={setdisableOk}
              commonStyle={{
                design: 'button-style',
                align: 'horizontal',
                width: 350,
                length: optionsObject.length,
                icon: true,
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            <button
              type='button'
              onClick={() => {
                genResend()
                sendtruevalue('genre', true)
                setshowPopup(false)
              }}
              className='btn btn-primary'
              disabled={disableOK}
            >
              OK
            </button>
          </Modal.Footer>
        </Modal>
      )}
      {genRe.length < 1 && <span className='mandatory1'>genre field should not be empty</span>}
    </div>
  )
}

export default Genre
